/**
 * ProductDetails - 产品详情交互（规格选择、数量、Bundle 切换、Accordion）
 * bundleOptions数据由Mpro.liquid页面传入
 */
var ProductDetails = {
  quantity: 1,
  selectedPack: '',
  activeBundleId: '',
  variants: [],
  selectedOptions: {},
  mediaid: '',//规格图片类
  bundleOptions: {},
  /*多属性新加变量*/
  morecount: 1,
  variantsoptions: [],
  /*多属性新加变量*/

  init: function (variantsData, selectedPack, selectedOptions) {
    // console.log("=== ProductDetails.init ===");
    console.log(variantsData);
    // console.log(selectedPack);

    // console.log("=== ProductDetails.init ===");

    // 获取所有匹配元素
    var shuxingList = document.querySelectorAll('.shuxinginfo');
    // 获取个数
    var count = shuxingList.length;


    const target = variantsData.find(item => item.title === selectedPack);
    if (target) {
      // 四位数字除以100，自动实现 6599 → 65.99
      const showPrice = target.price / 100;
      var mpro_price = document.getElementById('mpro_price');
      if (mpro_price) mpro_price.textContent = "$" + showPrice;
      console.log(showPrice);
    }
    this.variants = variantsData || [];

    this.selectedOptions = {};

    this.quantity = 1;
    this.updateQtyDisplay();
    if (count > 1) {
      // 多属性
      //console.log('variantsData count', count);
      // 你的特殊业务代码写这里
      this.morecount = count;
      this.variantsoptions = this.groupByOption1(variantsData) || [];
      // console.log("=== variantsoptions ===");
      // console.log(this.variantsoptions);
      // console.log("===variantsoptions ===");
      //依据selectedOptions来更新当前选中的variant
      this.selectedOptions = selectedOptions;
      this.updateVariant();
    }
    console.log(this.selectedOptions);
  },
  groupByOption1: function (variants) {
    var map = {};

    variants.forEach(function (variant) {
      var key = variant.option1;
      if (!map[key]) {
        map[key] = [];
      }
      // 只提取需要的字段，也可以直接 push 整个 variant
      map[key].push({
        option2: variant,
      });
    });

    var result = [];
    for (var key in map) {
      result.push({
        option1: key,
        childrenoption: map[key]
      });
    }

    return result;
  },
  incrementQty: function () {
    this.quantity++;
    this.updateQtyDisplay();
  },

  decrementQty: function () {
    this.quantity = Math.max(1, this.quantity - 1);
    this.updateQtyDisplay();
  },

  updateQtyDisplay: function () {
    var display = document.getElementById('qtyDisplay');
    if (display) display.textContent = this.quantity;

    var qtyInput = document.getElementById('Mpro-quantity');
    if (qtyInput) qtyInput.value = this.quantity;
  },

  selectPack: function (pack, btn) {
    this.selectedPack = pack;
    var buttons = document.querySelectorAll('#packSelector .pack-btn');
    buttons.forEach(function (b) {
      b.classList.remove('active', 'border-[#FFC439]', 'text-gray-900', 'bg-[#FFC439]/5');
      b.classList.add('border-gray-200', 'text-gray-600');
      b.classList.add('hover:border-gray-300');
    });
    btn.classList.remove('border-gray-200', 'text-gray-600', 'hover:border-gray-300');
    btn.classList.add('active', 'border-[#FFC439]', 'text-gray-900', 'bg-[#FFC439]/5');
  },

  selectOption: function (optionName, value, btn, optionIndex) {
    //console.log(this.selectedOptions);
    this.selectedOptions[optionName] = value;
    //console.log(this.selectedOptions);
    var groupId = 'packSelector-' + optionName.toLowerCase().replace(/\s+/g, '-');
    var buttons = document.querySelectorAll('#packSelector .pack-btn.pack-btn' + optionIndex);
    buttons.forEach(function (b) {
      b.classList.remove('active', 'border-[#FFC439]', 'text-gray-900', 'bg-[#FFC439]/5');
      b.classList.add('border-gray-200', 'text-gray-600', 'hover:border-gray-300');
    });

    btn.classList.remove('border-gray-200', 'text-gray-600', 'hover:border-gray-300');
    btn.classList.add('active', 'border-[#FFC439]', 'text-gray-900', 'bg-[#FFC439]/5');

    this.updateVariant();
  },

  updateVariant: function () {
    var selectedVariant = this.findMatchingVariant();

    // 保存滚动位置，防止渲染时页面跳动
    var scrollY = window.scrollY;
    var scrollX = window.scrollX;

    if (selectedVariant) {
      this.updateHiddenId(selectedVariant.id);
      this.updatePrice(selectedVariant);
      this.updateStockStatus(selectedVariant);
      this.updateImage(selectedVariant);
      this.updateGgName(selectedVariant);
      this.updateAddCartvariant(selectedVariant);
    }

    // 恢复滚动位置
    window.scrollTo(scrollX, scrollY);
  },
  updateAddCartvariant: function (variant) {
    var addToCartBtn = document.querySelector('.dbaddcart');
    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-variant-id', variant.id);
    }
  },
  findMatchingVariant: function () {
    if (this.morecount > 1) {
      var showText = Object.values(this.selectedOptions)
        .filter(item => item)
        .join(' / ');
      console.log("=== findMatchingVariant ===");
      console.log(showText);
      for (var i = 0; i < this.variants.length; i++) {
        var variant = this.variants[i];
        var match = true;
        console.log(variant.title);
        if (variant.title == showText) {
          return variant;
        }

      }

    } else {
      for (var i = 0; i < this.variants.length; i++) {
        var variant = this.variants[i];
        var match = true;

        for (var key in this.selectedOptions) {
          var optionValue = this.selectedOptions[key];
          var variantOption = variant[key.toLowerCase()] || variant['option1'] || variant['option2'] || variant['option3'];

          if (optionValue && variantOption !== optionValue) {
            match = false;
            break;
          }
        }

        if (match) {
          return variant;
        }
      }
    }


    return this.variants[0] || null;
  },

  updateHiddenId: function (variantId) {
    var hiddenInput = document.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = variantId;
    }

    var addToCartBtn = document.querySelector('add-to-cart#Mpro-add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.setAttribute('data-variant-id', variantId);
    }
  },

  updatePrice: function (variant) {
    var price = 0;
    if (variant.price) {
      var price = variant.price / 100;
    }
    var priceElement = document.querySelector('.product-price');
    if (priceElement && price) {

      priceElement.textContent = '$' + price.toFixed(2);
    }
    var priceElement1 = document.querySelector('.product-price1');
    if (priceElement1 && price) {
      console.log(priceElement1);
      priceElement1.textContent = '$' + price.toFixed(2);
    }
    var priceElement2 = document.querySelector('.product-price2');
    if (priceElement2 && price) {
    console.log(priceElement2);
      priceElement2.textContent = '$' + price.toFixed(2);
    }
    var compare_at_price = 0;
    if (variant.compare_at_price) {
      compare_at_price = variant.compare_at_price / 100;
    }
    var compare_at_price = document.querySelector('.compare_at_price');
    if (compare_at_price && price) {

      compare_at_price.textContent = '$' + compare_at_price.toFixed(2);
    }
    var compare_at_price11 = document.querySelector('.compare_at_price1');
    if (compare_at_price11 && compare_at_price) {

      compare_at_price11.textContent = '$' + compare_at_price.toFixed(2);
    }
  },

  updateStockStatus: function (variant) {
    var addToCartBtn = document.querySelector('.product-form__submit');
    if (!addToCartBtn) {
      var buttons = document.querySelectorAll('button');
      for (var i = 0; i < buttons.length; i++) {
        if (buttons[i].textContent.trim().toUpperCase() === 'ADD TO CART') {
          addToCartBtn = buttons[i];
          break;
        }
      }
    }
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = 'ADD TO CART';
        addToCartBtn.classList.remove('opacity-50', 'cursor-not-allowed');
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'SOLD OUT';
        addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
      }
    }
  },
  updateGgName: function (variant) {
    var ggNameElement = document.querySelector('.ggName');
    // console.log("=== updateGgName ===");
    // console.log(ggNameElement);
    // console.log(variant.title);
    if (ggNameElement && variant.title) {
      ggNameElement.textContent = variant.title;
    }
  },
  updateImage: function (variant) {

    // console.log("=== updateImage ===");
    // console.log(variant.featured_media);
    // console.log(this.mediaid);
    if (variant.featured_media && variant.featured_media.preview_image.src) {
      // 更新 MproProductGallery.media[0] 的 src 值
      if (MproProductGallery.media && MproProductGallery.media[0]) {
        MproProductGallery.media[0].src = variant.featured_media.preview_image.src;
      }

      // 重新渲染第0个索引，刷新显示
      MproProductGallery.render(0);
    }
    if (variant.featured_media && variant.featured_media.id) {

      var mainImage = document.querySelector('.' + this.mediaid);
      // 容器内部的第一张img
      var mainImage1 = document.querySelector('.' + this.mediaid + ' img');
      // console.log(mainImage1);
    if (mainImage1) {
        mainImage1.src = variant.featured_media.preview_image.src;
      }
      if (mainImage) {
        mainImage.classList.add('active');
      }
      /*mainImage1.src = variant.featured_media.preview_image.src;
      if (mainImage) {
        mainImage.click();
      }*/
      var fimgImage = document.querySelector('.fimg');

      if (fimgImage && variant.featured_media.preview_image.src) {
        fimgImage.src = variant.featured_media.preview_image.src;
      }
    }
    // console.log("=== updateImage ===");
  },

  selectBundle: function (bundleId, btn) {
    this.activeBundleId = bundleId;

    // Save active bundle ID to DOM
    var bundleContainer = document.getElementById('bundleContainer');
    if (bundleContainer) {
      bundleContainer.dataset.activeBundleId = bundleId;
    }

    // Update tab styles
    var tabs = document.querySelectorAll('#bundleTabs .bundle-tab');
    tabs.forEach(function (tab) {
      tab.classList.remove('text-[rgb(0,47,167)]');
      tab.classList.add('text-gray-500', 'hover:text-gray-900');
      var indicator = tab.querySelector('.tab-indicator, div[class*="h-0\\.5"]');
      if (indicator) indicator.remove();
    });
    btn.classList.add('text-[rgb(0,47,167)]');
    btn.classList.remove('text-gray-500', 'hover:text-gray-900');
    // Add active indicator
    var div = document.createElement('div');
    div.className = 'absolute bottom-[-1px] left-0 w-full h-0.5 bg-[rgb(0,47,167)] tab-indicator';
    btn.appendChild(div);

    this.renderBundleItems(bundleId);
  },

  renderBundleItems: function (bundleId) {
    // ✅ 从 <script type="application/json"> 读取 Bundle 数据
    var bundleDataScript = document.getElementById('bundleData');
    var bundleOptions = this.bundleOptions;

    if (bundleDataScript) {
      try {
        bundleOptions = JSON.parse(bundleDataScript.textContent);
      } catch (e) {
        console.error('Failed to parse bundle data:', e);
      }
    }

    var bundle = bundleOptions[bundleId];
    if (!bundle) return;

    var container = document.getElementById('bundleItems');
    if (!container) return;

    var html = '';
    bundle.items.forEach(function (item, index) {
      html += '<div class="flex items-center gap-4 bg-white p-3 rounded-lg border border-gray-100 shadow-sm" data-variant-id="' + item.id + '">';
      html += '<div class="w-16 h-16 bg-gray-100 rounded-md overflow-hidden flex-shrink-0">';
      html += '<img src="' + item.image + '" alt="' + item.name + '" class="w-full h-full object-cover" />';
      html += '</div>';
      html += '<div class="flex-1 flex flex-col justify-center">';
      html += '<h4 class="text-sm font-medium text-gray-900 leading-tight mb-1">' + item.name + '</h4>';
      html += '<div class="flex items-baseline gap-2">';
      html += '<span class="text-sm font-bold text-gray-900">$' + item.price.toFixed(2) + '</span>';
      if (item.originalPrice) {
        html += '<span class="text-xs text-gray-400 line-through">$' + item.originalPrice.toFixed(2) + '</span>';
      }
      html += '</div></div></div>';
      if (index === 0) {
        // html += '<div class="flex justify-center -my-1 relative z-10">';
        // html += '<div class="bg-white border border-gray-200 rounded-full p-1 shadow-sm text-gray-400">';
        // html += '<i data-lucide="plus" class="w-3 h-3"></i>';
        // html += '</div></div>';
      }
    });

    container.innerHTML = html;

    // Update total price
    var total = bundle.items.reduce(function (sum, item) { return sum + item.price; }, 0);
    var totalEl = document.getElementById('bundleTotalPrice');
    if (totalEl) totalEl.textContent = '$' + total.toFixed(2);

    // Refresh Lucide icons
    if (typeof lucide !== 'undefined') lucide.createIcons();
  },

  addBundleToCart: function (btn) {
    // ✅ 从 <script type="application/json"> 读取 Bundle 数据
    var bundleDataScript = document.getElementById('bundleData');
    var bundleOptions = {};

    if (bundleDataScript) {
      try {
        bundleOptions = JSON.parse(bundleDataScript.textContent);
      } catch (e) {
        alert('Failed to parse bundle data:', e);
      }
    }

    // 备用：如果 JSON script 中没有，尝试使用全局变量
    if (Object.keys(bundleOptions).length === 0) {
      bundleOptions = ProductDetails.bundleOptions || {};
    }

    var bundleContainer = document.getElementById('bundleContainer');
    var bundleId = ProductDetails.activeBundleId || (bundleContainer && bundleContainer.dataset.activeBundleId) || 'bundle1';
    var bundle = bundleOptions[bundleId];

    console.log('=== addBundleToCart debug ===');
    console.log('bundleOptions:', bundleOptions);
    console.log('bundleOptions keys:', Object.keys(bundleOptions));
    console.log('bundleId:', bundleId);
    console.log('bundle:', bundle);

    if (!bundle || !bundle.items || !bundle.items.length) {
      alert('Bundle is empty or not found');
      return;
    }

    var items = bundle.items.map(function (v) {
      return { id: v.id, quantity: 1 };
    });

    // Loading 状态
    btn.disabled = true;
    var originalHTML = btn.innerHTML;
    btn.innerHTML = `
    <svg class="animate-spin w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
    </svg> Adding...`;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble']
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        // ❌ 422 或其他错误
        if (!result.ok) {
          var msg = (result.data && result.data.description)
            ? result.data.description
            : 'Failed to add bundle. Please try again.';

          // 如果是缺货错误，追加联系客服提示
          if (result.status === 422 && msg.toLowerCase().includes('sold out')) {
            msg += '\n\nNeed help? Get in touch.';
          }

          alert(msg);
          return;
        }

        // ✅ 成功
        // 判断是否为手机端（屏幕宽度 < 768px）
        var isMobile = window.innerWidth < 768;

        if (isMobile) {
          // 手机端：直接跳转到购物车页面
          window.location.href = '/cart';
        } else {
          // 桌面端：打开 mini-cart
          var miniCartEl = document.querySelector('mini-cart');
          if (miniCartEl && result.data.sections) {
            miniCartEl.renderContents(result.data);

            // 触发 cart-drawer 打开
            var cartDrawerContainer = document.querySelector('.cart-drawer-container');
            if (cartDrawerContainer) {
              cartDrawerContainer.setAttribute('open', '');
            }
          } else {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && drawer.openMenuDrawer) {
              drawer.openMenuDrawer();
            }
          }
        }

        // 更新购物车图标数量
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count, #cart-count')
              .forEach(function (el) { el.textContent = cart.item_count; });
          });
      })
      .catch(function (err) {
        console.error('Bundle add failed:', err);
        alert('Something went wrong. Please try again or contact us');
      })
      .finally(function () {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
        if (window.lucide) lucide.createIcons();
      });
  },
};
